import { render } from "./Filtering.vue?vue&type=template&id=f35b81c4"
import script from "./Filtering.vue?vue&type=script&lang=js"
export * from "./Filtering.vue?vue&type=script&lang=js"

import "./Filtering.vue?vue&type=style&index=0&id=f35b81c4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__